import * as Types from '../action-types';

const globalDataActions = {
    setHeaderInfo(info) {
        return {
            type: Types.SET_HEADER_INFO,
            headerInfo: info
        };
    },
    setGlobalHotel(hotel) {
        return {
            type: Types.SET_GLOBAL_HOTEL,
            hotel
        };
    },
    setGlobalRoomCategory(roomCategory) {
        return {
            type: Types.SET_GLOBAL_ROOM_CATEGORY,
            roomCategory
        };
    }
};

export default globalDataActions;
